//@ts-check

/** @type {import('../types').DataType<string>} */
var MICROSERVICE_SETTINGS_DATA_TYPE = {
  data: {
    itemUrl: '/api/microservices/v1/settings?name={id}',
    createItemUrl: '/api/microservices/v1/settings',
    dataKey: 'microservicesettings',
    idKeyProp: null
  }
};
export default MICROSERVICE_SETTINGS_DATA_TYPE;